import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import type { DashboardRole } from "./useGetDashboardEventRoles";

type AdminDashboardEventMenuProps = {
  eventId: string;
  eventName: string;
  roles: DashboardRole[];
};

const createSalesDashboardPath = (eventId: string): string => {
  const searchParams = new URLSearchParams({ event_id: eventId });

  return `/admin/sales?${searchParams.toString()}`;
};

export const AdminDashboardEventMenu: React.FC<
  AdminDashboardEventMenuProps
> = ({ eventId, eventName, roles }) => {
  const history = useHistory();
  const [anchorElement, setAnchorElement] = useState<HTMLButtonElement | null>(
    null
  );
  const canViewSalesDashboard = roles.includes("sales_dashboard_viewer");

  const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElement(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorElement(null);
  };

  const handleOpenSalesDashboard = () => {
    handleCloseMenu();
    history.push(createSalesDashboardPath(eventId));
  };

  return (
    <>
      <IconButton
        aria-label={`${eventName}の操作メニュー`}
        aria-haspopup="menu"
        disabled={!canViewSalesDashboard}
        type="button"
        onClick={handleOpenMenu}
      >
        <MoreVertIcon aria-hidden="true" />
      </IconButton>

      {canViewSalesDashboard && (
        <Menu
          anchorEl={anchorElement}
          open={Boolean(anchorElement)}
          onClose={handleCloseMenu}
        >
          <MenuItem onClick={handleOpenSalesDashboard}>
            売上ダッシュボード
          </MenuItem>
        </Menu>
      )}
    </>
  );
};
